<script lang="ts">
    import type { Snippet } from "svelte";
    import { videoStreamElementsStore } from "../../Stores/PeerStore";
    import { blocker } from "../../Utils/screenBlocker";
    import { highlightFullScreen } from "../../Stores/ActionsCamStore";

    interface Props {
        left?: Snippet;
        center?: Snippet;
        right?: Snippet;
    }

    let { left, center, right }: Props = $props();

    let isInCall = $derived($videoStreamElementsStore.length > 0);
</script>

<div
    class="@container/actions pointer-events-none fixed bottom-0 end-0 start-12 z-[301] flex justify-center bp-menu md:inset-x-0 {$videoStreamElementsStore.length >
        0 && $highlightFullScreen
        ? 'hidden'
        : ''}"
>
    <div
        data-testid="nutrivera-action-dock"
        data-call-active={isInCall}
        {@attach blocker}
        class="pointer-events-auto mb-[max(10px,env(safe-area-inset-bottom))] flex h-14 max-w-full items-center gap-1 rounded-[14px] border border-solid border-[var(--nutrivera-shell-border)] bg-[var(--nutrivera-shell-bg)] p-1.5 text-[var(--nutrivera-shell-text)] shadow-[0_8px_20px_rgb(0_0_0/35%)] max-[340px]:gap-0 max-[340px]:p-1 md:max-w-[calc(100dvw-64px)]"
    >
        {@render left?.()}
        {@render center?.()}
        <div class="contents max-[340px]:hidden">
            {@render right?.()}
        </div>
    </div>
</div>
